import { render, staticRenderFns } from "./OrderDetailModal.vue?vue&type=template&id=425ea9cb&"
import script from "./OrderDetailModal.vue?vue&type=script&lang=js&"
export * from "./OrderDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports